import styled from 'styled-components';

export default styled.div<{ backgroundColor: string }>`
  width: 80px;
  height: 20px;
  border-radius: 4px;
  background-color: ${({ backgroundColor }): string => backgroundColor};
`;
